interface FreeTextInputProps {
    value: string;
    onChange: (value: string) => void;
}

export function FreeTextInput({ value, onChange }: FreeTextInputProps) {
    return (
        <textarea
            rows={3}
            placeholder="Describe how you'd like to adjust your request..."
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="block w-full appearance-none rounded-md border-0 bg-[#f3f3f5] px-2.5 py-1.5 text-sm text-gray-900 shadow-xs outline-hidden placeholder-gray-400 transition focus:border-[#079a95] focus:ring-2 focus:ring-[#079a95]/20"
        />
    );
}
